module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14afFJt/tc-custom/9781426867477.jpg?1726519051692",
      "alt": "This image is the cover for the book Sudden Engagement, The Taylor Clan"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sudden Engagement, The Taylor Clan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("With blazing blue eyes and beckoning broad shoulders, Brett Taylor was irresistible to most women. But Detective Ginny Rafferty wasn't about to succumb to his potent charm. The lady cop had learned early about love and betrayal, and buried her feelings beneath her badge. So the last thing she wanted was to pose as the brawny neighborhood hero's adoring fiancée, especially since she went weak in the knees every time he came too close. However, they had each lost a loved one to the killer they hunted, and Ginny needed Brett's connections to catch the perpetrator. Except she knew better than anyone that this sudden engagement could endanger her heart--and her life. But some things were worth the risk.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julie Miller\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("USA TODAY bestselling author Julie Miller writes breathtaking romantic suspense. She has sold millions of copies of her books worldwide, and has earned a National Readers Choice Award, two Daphne du Maurier prizes and an RT BookReviews Career Achievement Award. For a complete list of her books and more, go to "), _c('a', {
    attrs: {
      "href": "http://www.juliemiller.org"
    }
  }, [_vm._v("www.juliemiller.org")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0